<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()" (dataExportToExcel) = "callprocssData()"  (tabledata)="getTableData()" [displayData]="displayData"  [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getNewTableData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded" [showExportBtn]="showExportBtn"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss" >
  <div class="modal-header modalTitle">
    <div class="modal-title">User Creation Form</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <mat-tab-group mat-align-tabs="center" [selectedIndex]='selectedIndextab' (selectedTabChange)="tabClick($event)">
      <mat-tab label="Add User">
        <div class="form-group mar_top">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text radius-0"><i class="fa fa-user fa-fw"></i></div>
            </div>
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="userName" placeholder="Name">
          </div>
        </div>
        <div class="form-group ">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text radius-0"><i class="fa fa-user fa-fw"></i></div>
            </div>
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="loginName" placeholder="Login ID">
          </div>
        </div>
        <div class="form-group">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text radius-0"><i class="fa fa-phone"></i></div>
            </div>
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="mobile" placeholder="Contact Number">
          </div>
        </div>
        <div class="form-group">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text radius-0"><i class="fa fa-envelope-o fa-fw"></i></div>
            </div>
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="email"
                   placeholder="Email ID">
          </div>
        </div>
        <div class="form-group">
          <textarea class="form-control radius-0 font-13" [(ngModel)]="address" placeholder="Address"></textarea>
        </div>
        <div class="form-group">
          <input type="password" class="form-control radius-0 font-13" [(ngModel)]="password"
                 placeholder="Initial Password">
        </div>
          <div class="form-group font-13">
              <mat-checkbox [(ngModel)]="isServiceUser">Service User</mat-checkbox>
          </div>
        <div class=" pad-8">
          <button type="button" class="btn btn-danger float-right radius-0 " (click)="c()">Cancel</button>
          <button type="button" class="btn btn-success float-right radius-0 mar_Right" (click)="save()">Save</button>
    
        </div>
      </mat-tab>
      <mat-tab label="Bulk User Creation">       
       <div class="modal-body">
             <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
           <div class="row mar-lft-rgt-0">
         <div class="col-sm-6 pad-15 text-center">
             <div class="form-group">
              <input type="text" class="form-control mr-sm-1 radius-0 font-13" [(ngModel)]="roleId"
              placeholder="Role ID">
                <!--  <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="updateStatusSelected"
                           (change)="onChangeUpdateStatus($event.target.selectedIndex)">
                   <option *ngFor="let obj of updateStatus" [value]="obj.id">{{obj.name}}</option>
                 </select> -->
               </div>
           <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                    (complete)="onFileComplete($event)" [formData]="formData"></app-material-fileupload>
         </div>
         <div class="col-sm-6 pad-15 text-center">
           <div class="form-group">
            <input type="text" class="form-control mr-sm-1 radius-0 font-13" [(ngModel)]="menuId"
            placeholder="Menu ID" required>
             <!-- <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelectedForTemplate"
                         (change)="onTicketChange($event.target.selectedIndex)">
               <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
             </select> -->
           </div>
           <div class="form-group">
            <input type="text" class="form-control mr-sm-1 radius-0 font-13" [(ngModel)]="supportGrpId"
            placeholder="Support Group ID" required>
            <!--  <mat-checkbox [(ngModel)]="enablePriority">Priority Required ?</mat-checkbox> -->
           </div>
           <button [disabled]="initiateprocessbtndisabled" type="button" class="btn btn-primary radius-0" (click)="processUserMaster()">Process User Master Data</button>
           <div class="pad-5 text-center" [innerHTML]="userCreationMessage"></div>
         </div>
       </div>
           <div class="row mar-lft-rgt-0">
         <div class="col-sm-6 pad-15 text-center" [innerHTML]="uploadSuccessMessage"></div>
       </div>
       </div>
      </mat-tab>
      <mat-tab label="Update Login ID">       
       <div class="modal-body">
        <div class="form-group">
          <mat-checkbox [(ngModel)]="singleLoginIDUpdate" (change)="singleLoginIDUpdateF()">Single LoginID Update</mat-checkbox>
          <mat-checkbox [(ngModel)]="multipleLoginIDUpdate" (change)="multipleLoginIDUpdateF()">Bulk LoginID Update</mat-checkbox>
        </div>
        <div class="row mar-lft-rgt-0">
        <div class="col-sm-12 pad-15 text-center">
          <div class="modal-body">
            <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
            <div class="form-group mar_top">
                <input type="text" class="form-control radius-0 font-13" placeholder="Present Login ID"
                       [(ngModel)]="userSelected" [hidden]="singleLoginIDUpdateFlag"
                       matInput [formControl]="searchUser"[matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
                    <mat-option *ngIf="isLoading" class="is-loading">
                        <mat-spinner diameter="50"></mat-spinner>
                    </mat-option>
                    <ng-container *ngIf="!isLoading">
                        <mat-option *ngFor="let user of usrs" [value]="user.login_name">
                          {{ user.name }} - {{user.login_name}}
                        </mat-option>
                    </ng-container>
                </mat-autocomplete>
            </div>
          
            <div class="form-group">
                <input type="text" class="form-control radius-0 font-13" [hidden]="singleLoginIDUpdateFlag" placeholder="User Name" readonly
                       [(ngModel)]="userName">
               
            </div>
            <div class="form-group">
              
              <input type="text" class="form-control  radius-0 font-13" [(ngModel)]="newLoginID"
                     [hidden]="singleLoginIDUpdateFlag" placeholder="New Login ID">
          </div>
          </div>
          <div class="form-group">
           <!--  <input type="text" class="form-control mr-sm-1 radius-0 font-13" [(ngModel)]="oldLoginID"
            [hidden]="singleLoginIDUpdateFlag" placeholder="Old Login ID"> -->
             <!--  <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="updateStatusSelected"
                        (change)="onChangeUpdateStatus($event.target.selectedIndex)">
                <option *ngFor="let obj of updateStatus" [value]="obj.id">{{obj.name}}</option>
              </select> -->
            </div>
            <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                    (complete)="onFileComplete($event)" [formData]="formData" [hidden]="multipleLoginIDUpdateFlag"></app-material-fileupload>
        </div>
            <div class="col-sm-12 text-center">
              <div class="form-group">
                <!-- <input type="text" class="form-control mr-sm-1 radius-0 font-13" [(ngModel)]="newLoginID"
                [hidden]="singleLoginIDUpdateFlag" placeholder="New Login ID"> -->
                <!-- <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelectedForTemplate"
                            (change)="onTicketChange($event.target.selectedIndex)">
                  <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
                </select> -->
              </div>
        </div>
        </div>
        <button [disabled]="updateLoginID" type="button" class="btn btn-primary float-right radius-0 mar_Right" (click)="updateUserLoginID()">Update</button>
       
      </div>

      </mat-tab>

    </mat-tab-group> 
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search  user</div>
  </div>
  <div class="modal-body">
      <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Login ID OR Name"
                 [(ngModel)]="userSelected"
                 matInput [formControl]="searchUser"[matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
              <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let user of usrs" [value]="user.login_name">
                    {{ user.name }} - {{user.login_name}}
                  </mat-option>
              </ng-container>
          </mat-autocomplete>
      </div>
    
      <div class="form-group">
          <input type="text" class="form-control radius-0 font-13" placeholder="User Name" readonly
                 [(ngModel)]="userName">
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0 mar_Right" (click)="search()">search</button>
          <button type="button" class="btn btn-danger float-right radius-0 " (click)="c()">Cancel</button>
  </div>
  </ng-template>
<notifier-container></notifier-container>
